export default "__VITE_ASSET__CjeLAdh7__"